import { createStyles } from 'antd-style';
import { appInfo } from '@/config/app';

const useStyles = createStyles(({ token, css }) => ({
  footer: css`
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 4px 8px;
    padding: 12px 24px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
    color: ${token.colorTextSecondary};
    font-size: ${token.fontSizeSM}px;
    line-height: ${token.lineHeight};
    text-align: center;
  `,
}));

export default function Footer() {
  const { styles } = useStyles();
  return (
    <footer className={styles.footer}>
      <span>
        {appInfo.name} &copy; {new Date().getFullYear()}
      </span>
    </footer>
  );
}
